import { C, T, H } from '@homeschooling/sdk'

import m from 'moment'
import * as React from 'react'
import * as _ from 'lodash'

import Persistance from "../Persistence";
import { InputField } from './InputField'

import { Exit } from '../../Components/Icons'
import { InputSwitch } from 'primereact/inputswitch'
import { DatePicker } from '../Common'
import { HorizontalLine } from '../Common/HorizonalLine'
import SDKFactory from '../../Components/SDKFactory'
import { Caret } from '../../Components/Icons'

interface Form {
    [key: string]: string
}

export interface Props {
    children?: React.ReactNode
    inPlaceUpdate: () => void
    closeForm: () => void
    schedule: T.Schedule
    date: string
}

export interface State {
    expandExpenses: boolean
    expandNotes: boolean
    form: Form
    students: T.Student[]
    errors: { [key: string]: string }
    editType: string
    showEditMenu: boolean
    submitted: boolean
}

Persistance.setValues()

export class EditScheduleForm extends React.Component<Props, any> {
    private sdk = SDKFactory.getScheduleSDK()
    private wrapperRef = React.createRef<HTMLInputElement>();

    public constructor(props: Props) {
        super(props)

        let schedule = this.props.schedule
        let days = schedule.days_of_week as number

        let form = {
            name: schedule.name,
            days_of_week: H.getDaysFromBinary(days),
            student: schedule.students[0].id?.toString(),
            subject: schedule.subject,
            course: schedule.course,
            description: schedule.description,
            location: schedule.location,
            provider: schedule.provider,
            all_day: schedule.all_day,
            startDate: schedule.start_date,
            endDate: schedule.end_date,
            startTime: m(schedule.starts_at, 'HH:mm:ss').format('HH:mm'),
            endTime: m(schedule.ends_at, 'HH:mm:ss').format('HH:mm'),
            repeating: schedule.repeating,
            transcript: schedule.add_to_transcript,
            indefinite: schedule.end_date === '9999-12-30' ? 'true' : 'false',
            expenses: [],
            notes: [],
            sun: 'false',
            mon: 'false',
            tues: 'false',
            wed: 'false',
            thurs: 'false',
            fri: 'false',
            sat: 'false',
            exception_end_date: schedule.exception_end_date ?? this.props.date,
            exception_start_date: schedule.exception_start_date ?? this.props.date,
            submitted: false,
            tz: schedule.tz
        }

        let daysArray = H.getDaysFromBinary(days)

        for (let a of daysArray) {
            switch (a) {
                case 0:
                    form['sun'] = 'true'
                    break;
                case 1:
                    form['mon'] = 'true'
                    break;
                case 2:
                    form['tues'] = 'true'
                    break;
                case 3:
                    form['wed'] = 'true'
                    break;
                case 4:
                    form['thurs'] = 'true'
                    break;
                case 5:
                    form['fri'] = 'true'
                    break;
                case 6:
                    form['sat'] = 'true'
                    break;
            }
        }

        let editType = this.props.schedule?.repeating === '1TIME' ? 'ALLEDIT' : null
        
        this.state = {
            expandExpenses: false,
            expandNotes: false,
            students: Persistance.getStudents(),
            form: form,
            editType: editType,
            showEditMenu: false,
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event: any) {
        if (this.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
            if (this.state.showEditMenu) {
                this.setState({ showEditMenu: false })
            }
        }
    }

    public setEditType = (type: string) => {
        let form = this.state.form
        form.exception_start_date = this.props.date
        form.exception_end_date = this.props.date

        if (type === 'EDITSERIES') {
            form.exception_start_date = this.props.schedule.exception_start_date
            if (this.props.schedule.exception_end_date !== '9999-12-31') form.exception_endPDate = this.props.schedule.exception_end_date
        }

        this.setState({ editType: type, showEditMenu: false })
    }

    public editEvent = () => {

        this.setState({submitted: true})

        let errors = this.verifyForm()

        if (Object.keys(errors).length !== 0) {
            this.setState({ errors: errors, submitted: false })
            return
        }

        let formData = this.state.form
        this.prepEvent(formData)

    }
    public verifyForm = () => {
        const { form } = this.state
        let errors: any = {}

        if (!form.name) errors['name'] = 'Name is required'
        if (!form.subject) errors['subject'] = 'Select a subject'
        if (!form.course) errors['course'] = 'Select a course'
        if (!form.student) errors['student'] = 'Select a student'
        if (!form.repeating) errors['repeating'] = 'Select a repeating option'
        //if (!form.description) errors['description'] = 'Description is required'
        if (!m(form.startDate).isValid()) errors['startDate'] = 'Valid start date is required'
        if (!m(form.endDate).isValid()) errors['endDate'] = 'Valid end date is required'
        if (!this.state.editType) errors['editType'] = 'Select an edit type'

        if (!form.allDay) {

            let start = m(form.startTime, 'HH:mm', true)
            let end = m(form.endTime, 'HH:mm', true)
            console.log((end.isBefore(start, 'minutes')))
            if (!start.isValid()) errors['startTime'] = 'Start time is required'
            if (!end.isValid()) errors['endTime'] = 'End Time is required'
            //if (end.isBefore(start, 'minutes')) errors['endDate'] = 'End date can not be before start date'
        }

        if (this.state.editType === 'RANEDIT') {

            let start = m(form.exception_start_date)
            let end = m(form.exception_end_date)

            if (end.isBefore(start, 'minutes')) errors['exception_end_date'] = 'End date can not be before start date'
        }

        return errors
    }

    public prepEvent = async (event?: Form) => {
        let { form } = this.state

        form = event ? event : form

        let days = H.buildBinaryFromDays(
            form['sun'] === 'true',
            form['mon'] === 'true',
            form['tues'] === 'true',
            form['wed'] === 'true',
            form['thurs'] === 'true',
            form['fri'] === 'true',
            form['sat'] === 'true')

        let end_date = form['indefinite'] === 'true' ? '9999-12-30' : m(form['endDate']).format('YYYY-MM-DD')

        let student = { id: form['student'] } as T.Student

        let data: T.Schedule = {
            name: form['name'],
            days_of_week: days,
            students: [student],
            subject: form['subject'],
            course: form['course'],
            description: form['description'],
            location: form['location'],
            provider: form['provider'],
            all_day: form['allDay'] === 'true',
            start_date: m(form['startDate']).format('YYYY-MM-DD'),
            end_date: end_date,
            starts_at: form['startTime'],
            ends_at: form['endTime'],
            repeating: form['repeating'],
            add_to_transcript: form['transcript'] === 'true',
            expenses: [],
            notes: [],
            exception_type: this.state.editType,
            exception_id: this.props.schedule.exception_id ?? '0',
            id: this.props.schedule.id,
            exception_start_date: this.props.date,
            exception_end_date: this.props.date,
            tz: form['tz']
        }


        switch (this.state.editType) {
            case 'FUTEDIT':
                data.exception_end_date = m(this.props.date).format('YYYY-MM-DD')
                break
            case 'RANEDIT':
                data.exception_start_date = this.state.form.exception_start_date
                data.exception_end_date = this.state.form.exception_end_date
                break
        }

        await this.editScheduleEvent(data)
    }


    public editScheduleEvent = async (data: T.Schedule) => {
        try {

            //let start_date = this.state.schedule.startDate
            //let end_date = this.state.schedule.endDate

            let id = this.props.schedule.id ?? 0
            const res = await this.sdk.patchSchedule(id.toString(), data)

            let sche = res.data
            const hasError: boolean = _.get(sche, 'errors', false) as boolean

            if (!hasError && res.status === 'success') {
                //let data = sche as T.ScheduleDay[]
                this.setState({submitted: false})
                this.props.inPlaceUpdate()
                this.props.closeForm()
            }
        } catch (reason) {
            this.setState({submitted: false})
            console.log('Error saving schedule event', reason)
        }
    }

    public toggleAllDay = () => {

        let allDay = 'false'

        if (!this.state.form.allDay || this.state.form.allDay === 'false') {
            allDay = 'true'
        }

        const { form } = this.state
        form['allDay'] = allDay
        this.setState({ form })
    }

    public toggleIndefinite = () => {

        let indefinite = 'false'

        if (!this.state.form.indefinite || this.state.form.indefinite === 'false') {
            indefinite = 'true'
        }

        const { form } = this.state
        form['indefinite'] = indefinite
        this.setState({ form })
    }

    public inputChanged = (key: string) =>
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const { form } = this.state
            form[key] = e.target.value

            this.setState({
                form,
            })
        }

    public setRepeatingOptions = (key: string) =>     
            (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                const { form, errors } = this.state
                form[key] = e.target.value
                delete errors[key]
    
                if(e.target.value === '1TIME') {
                    form['endDate'] = form['startDate']
                    let day = m(form['startDate']).day()
                    switch(day) {
                        case 0:
                           form['sun'] = 'true'
                           break;
                        case 1:   
                            form['mon'] = 'true'
                            break;
                        case 2:
                            form['tues'] = 'true'
                            break;
                        case 3:
                            form['wed'] = 'true'
                            break;
                        case 4:
                            form['thurs'] = 'true'
                            break;
                        case 5:
                            form['fri'] = 'true'
                            break;
                        case 6:
                            form['sat'] = 'true' 
                        break;
                    }
                }
    
                this.setState({
                    form,
                })
            }
    
        public resetDays = () => {
            const { form } = this.state
            form['sun'] = 'false'
            form['mon'] = 'false'
            form['tues'] = 'false'
            form['wed'] = 'false'
            form['thurs'] = 'false'
            form['fri'] = 'false'
            form['sat'] = 'false'
            this.setState({form})
        }    
    
        public setDatePickerFormInfo = (key: string, e: any) => {
            const { form } = this.state
            form[key] = m(e).format()
    
            if(key === 'startDate' && form['repeating'] === '1TIME') {
                form['endDate'] = m(e).format()
                this.resetDays()
                let day = m(e).day()
                    switch(day) {
                        case 0:
                           form['sun'] = 'true'
                           break;
                        case 1:   
                            form['mon'] = 'true'
                            break;
                        case 2:
                            form['tues'] = 'true'
                            break;
                        case 3:
                            form['wed'] = 'true'
                            break;
                        case 4:
                            form['thurs'] = 'true'
                            break;
                        case 5:
                            form['fri'] = 'true'
                            break;
                        case 6:
                            form['sat'] = 'true' 
                        break;
                    }
            }
    
            this.setState({
                form,
            })
    
        }
    

    public toggleAddToTranscripts = () => {
        let transcripts = 'false'

        if (!this.state.form.transcripts || this.state.form.transcripts === 'false') {
            transcripts = 'true'
        }

        const { form } = this.state
        form['transcripts'] = transcripts
        this.setState({ form })
    }

    public toggleScheduleDay = (key: string) => {
        const { form } = this.state

        if (form[key] === 'true') {
            form[key] = 'false'
        } else {
            form[key] = 'true'
        }

        this.setState({
            form,
        })
    }

    public getStudentOptions = () => {
        let options: any = []

        for (let s of this.state.students) {
            options[s.id] = s.name
        }

        return options
    }

    public getRepeatsOption = () => {
        let repeats = C.repeating

        let options: any = []

        _.forOwn(repeats, (value, key) => {
            options[key] = value.label
        })

        return options
    }

    public getSubjectOption = () => {
        let subjects = C.subject

        let options: any = []

        _.forOwn(subjects, (value, key) => {
            options[key] = value.label
        })

        return options
    }

    public getCourseOption = () => {

        let options: any = []

        if (this.state.form.subject) {
            let courses = C.getSubjectConstants(this.state.form.subject)

            _.forOwn(courses, (value, key) => {
                options[key] = value.label
            })
        }

        return options
    }

    public getStartTImeSection = () => {


        const { form } = this.state

        if (this.state.form.allDay === 'true') {
            return (<div></div>)
        }

        return (
            <div className='w-full my-2'>
                            <div className='w-full grid grid-col gap-2'>
                                <div className='w-full'>
                                    <div className='w-full my-2 flex flex-col relative'>
                                        <div className='w-1/2'>
                                            Start Date*
                                        </div>
                                        <div className='w-full'>
                                            <DatePicker
                                                date={m(this.state.form.startDate).format()} cb={(e) => this.setDatePickerFormInfo('startDate', e)} />
                                        </div>
                                    </div>
                                </div>
                                { this.state.form.allDay !== 'true' &&
                                                    <div className='w-full flex flex-col'>
                                                        <div className='w-full grid grid-cols-2 gap-2'>
                                                        <div>
                                                                    <InputField
                                                                        borderColor='default'
                                                                        cb={this.inputChanged('startTime')}
                                                                        disabled={false}
                                                                        errors={this.state.errors?.startTime}
                                                                        helperErrors={true}
                                                                        label={'Start Time'}
                                                                        labelColor='default'
                                                                        id='startTime'
                                                                        required={true}
                                                                        options={C.gettimes()}
                                                                        type='select'
                                                                        value={form.startTime}
                                                                        placeHolder='Start Time'
                                                                    >
                                                                    </InputField>
                                                        </div>
                                                        <div>
                                                              <InputField
                                                                        borderColor='default'
                                                                        cb={this.inputChanged('endTime')}
                                                                        disabled={false}
                                                                        errors={this.state.errors?.endTime}
                                                                        helperErrors={true}
                                                                        label={'End Time'}
                                                                        labelColor='default'
                                                                        id='endTime'
                                                                        required={true}
                                                                        options={C.gettimes()}
                                                                        type='select'
                                                                        value={form.endTime}
                                                                        placeHolder='End Time'
                                                                    >
                                                                    </InputField>
                                                            </div>
                                                    </div>
                                                    <div className="w-full flex">
                                                                    <dd className="text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                                                        
                                                                                                            <InputField
                                                                                                                borderColor='default'
                                                                                                                cb={this.inputChanged('tz')}
                                                                                                                disabled={false}
                                                                                                                errors={this.state.errors?.tz}
                                                                                                                helperErrors={true}
                                                                                                                label={'Timezone'}
                                                                                                                labelColor='default'
                                                                                                                id='startTime'
                                                                                                                required={true}
                                                                                                                options={C.getTzOptions()}
                                                                                                                type='select'
                                                                                                                value={form.tz}
                                                                                                                placeHolder='Select Timezone'
                                                                                                            >
                                                                                                            </InputField>
                                                                            
                                                                    </dd>
                                                                </div>
                                                    </div>
                                }
                            </div>
                        </div>
                    )
    }

    public repeatingSection = () => {

        return (
            <div>
                {(this.state.form.repeating && this.state.form.repeating !== '1TIME') && 
                                <div className='w-full my-4 flex flex-col'>
                                    <div className='flex flex-rows justify-end'>
                                    <div className='w-auto pr-2'>
                                        Repeat Indefinitely
                                    </div>
                                    <div className='w-auto'>
                                        <InputSwitch checked={this.state.form.indefinite === 'true'} onChange={(e) => this.toggleIndefinite()} />
                                    </div>
                                    </div>
                                    {this.state.form.indefinite !== 'true' &&
                                    <div className='w-full flex flex-row'>
                                        <div className='w-full my-4 flex flex-col relative'>
                                            <div className='w-full'>
                                                Repeat Until
                                            </div>
                                            <div className='w-full'>
                                                <DatePicker
                                                    date={m(this.state.form.endDate).format()} cb={(e) => this.setDatePickerFormInfo('endDate', e)} />
                                            </div>
                                        </div>
                                    </div>}
                                </div>}
                <div className='w-full'>Pick days of week event takes place.</div>
                <div className='w-full my-4 flex flex-col items-center'>
                    <div className="inline-flex rounded-md shadow-sm" role="group">
                        <button type="button" onClick={(e) => this.toggleScheduleDay('sun')}
                            className={(this.state.form['sun'] === 'true' ? 'selected-btn' : 'select-btn') + ' rounded-s-lg'}>
                            Sun
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('mon')}
                            className={(this.state.form['mon'] === 'true' ? 'selected-btn' : 'select-btn')}>
                            Mon
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('tues')}
                            className={(this.state.form['tues'] === 'true' ? 'selected-btn' : 'select-btn')}>
                            Tues
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('wed')}
                            className={(this.state.form['wed'] === 'true' ? 'selected-btn' : 'select-btn')}>
                            Wed
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('thurs')}
                            className={(this.state.form['thurs'] === 'true' ? 'selected-btn' : 'select-btn')}>
                            Thurs
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('fri')}
                            className={(this.state.form['fri'] === 'true' ? 'selected-btn' : 'select-btn')}>
                            Fri
                        </button>
                        <button type="button" onClick={(e) => this.toggleScheduleDay('sat')}
                            className={(this.state.form['sat'] === 'true' ? 'selected-btn' : 'select-btn') + ' rounded-e-lg'}>
                            Sat
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    public render(): React.ReactNode {

        const { form } = this.state

        let editMenuLabel = 'Select Edit Type'

        if (this.state.editType !== null && !this.state.showEditMenu) {
            switch (this.state.editType) {
                case 'ALLEDIT':
                    editMenuLabel = 'Edit All Occurances of event'
                    break
                case 'SINGEDIT':
                    editMenuLabel = 'Edit Single Occurance of event'
                    break
                case 'FUTEDIT':
                    editMenuLabel = 'Edit All Future Occurances of event'
                    break
                case 'RANEDIT':
                    editMenuLabel = 'Edit Occurances of event in range'
                    break
                case 'EDITSERIES':
                    editMenuLabel = 'Edit series of event'
                    break
            }
        }

        return (
            <div className='w-120 flex flex-col'>
                <div className='w-full flex flew-row items-center'>
                    <h2 className='w-auto grow text-left text-l font-semibold text-gray-900'>Edit Event</h2>
                    <div onClick={() => this.props.closeForm()} className='w-auto flex-none text-right justify-items-end hover:cursor-pointer'>
                        <Exit size='small' />
                    </div>
                </div>

                <form noValidate className="space-y-4 md:space-y-6">
                    <div className='w-full flex flex-col'>
                        <div className='w-full my-2'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('name')}
                                disabled={false}
                                errors={this.state.errors?.name}
                                helperErrors={true}
                                label={'Add Event Name'}
                                labelColor='default'
                                id='event_name'
                                required={true}
                                type='heroText'
                                value={form.name}
                                placeHolder='Add Event Name'
                            >

                            </InputField>
                        </div>


                        {this.props.schedule?.repeating !== '1TIME'&&
                        <div>
                        <div className='w-full'>
                            <HorizontalLine
                                color='#999999'
                                size='1px'
                                padding='3.5em' />
                        </div>
                        <div ref={this.wrapperRef} className='w-full py-2'>
                            <div className='w-full'>
                                <button
                                    className='w-full inline-block text-left px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white'
                                    onClick={() => this.setState({ showEditMenu: !this.state.showEditMenu })}
                                    type="button">
                                    <div className='w-full flex flex-row items-center'>
                                        <div className='flex-grow'>{editMenuLabel}</div>
                                        <div className='none rotate-180'><Caret size='small' /></div>
                                    </div>
                                </button>
                                {this.state.errors?.editType &&
                                    <div className='w-full text-xs text-red-500 my-1'>Select a valid edit type</div>
                                }
                            </div>
                            {this.state.showEditMenu && <ul className="absolute z-10 mt-1 w-content origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden">
                                <li>
                                    <button type='button' onClick={() => this.setEditType('ALLEDIT')} className="block text-left w-full text-slate-800 p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Edit All Occurances of event</button>
                                </li>
                                <li>
                                    <button type='button' onClick={() => this.setEditType('SINGEDIT')} className="block text-left  w-full text-slate-800 p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Edit Single Occurance of event</button>
                                </li>
                                <li>
                                    <button type='button' onClick={() => this.setEditType('FUTEDIT')} className="block text-left  w-full text-slate-800 p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Edit All Future Occurances of event</button>
                                </li>
                                <li>
                                    <button type='button' onClick={() => this.setEditType('RANEDIT')} className="block text-left  w-full text-slate-800 p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Edit Occurances of event in range</button>
                                </li>
                                {(this.props.schedule.exception_id && Number(this.props.schedule.exception_id) > 0) &&
                                    <li>
                                        <button type='button' onClick={() => this.setEditType('EDITSERIES')} className="block text-left  w-full text-slate-800 p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Edit series of event</button>
                                    </li>}
                            </ul>}
                        </div> 
                            <div className='w-full grid grid-cols-2 gap-2 py-2'>
                                 {(this.state.editType === 'RANEDIT' || this.state.editType === 'EDITSERIES') &&
                                 <div className='grid-span-full sm:grid-span-1 relative'>
                                    <div className=' text-small text-gray-800'>
                                        Start Date
                                    </div>
                                    <div className='w-full'>
                                              <DatePicker date={m(this.state.form.exception_start_date).format('YYYY-MM-DD')} cb={(e) => this.setDatePickerFormInfo('exception_start_date', e)} />                 
                                       </div>
                                </div>}
                                {this.state.editType === 'RANEDIT' && 
                                    <div className='grid-span-full sm:grid-span-1 relative'>
                                        <div className=' text-small text-gray-800'>
                                            End Date
                                        </div>

                                        <div className='w-full'>
                                              <DatePicker date={m(this.state.form.exception_end_date).format('YYYY-MM-DD')} cb={(e) => this.setDatePickerFormInfo('exception_end_date', e)} />
                                           </div>
                                    </div>
                                }
                            </div>
                        <div className='w-full'>
                            <HorizontalLine
                                color='#999999'
                                size='1px'
                                padding='3.5em' />
                        </div>
                        </div>
                        }
                        {this.state.editType !== null &&
                            <div className='w-full'>
                                <div className='w-full my-2'>
                                    <InputField
                                        borderColor='default'
                                        cb={this.inputChanged('student')}
                                        disabled={false}
                                        errors={this.state.errors?.student}
                                        helperErrors={true}
                                        label={'Select A Student'}
                                        labelColor='default'
                                        id='student'
                                        required={true}
                                        options={this.getStudentOptions()}
                                        type='select'
                                        value={form.student}
                                        placeHolder='Choose A Student'
                                    >

                                    </InputField>
                                </div>
                                <div className='w-full my-2 flex flex-row'>
                                    <div className='w-1/2 flex flex-row justify-end'>
                                        <div className='w-auto text-sm pr-2'>
                                            Add event to transcripts
                                        </div>
                                        <div className='w-auto'>
                                            <InputSwitch checked={this.state.form.transcripts === 'true'} onChange={(e) => this.toggleAddToTranscripts()} />
                                        </div>
                                    </div>
                                    <div className='w-1/2 flex flex-row justify-end'>
                                        <div className='w-auto text-sm pr-4'>
                                            All Day Event
                                        </div>
                                        <div className='w-auto text-right'>
                                            <InputSwitch checked={this.state.form.allDay === 'true'} onChange={(e) => this.toggleAllDay()} />
                                        </div>
                                    </div>
                                </div>
                                {this.getStartTImeSection()}
                                <div className='w-full my-2 flex flex-row'>
                                    <InputField
                                        borderColor='default'
                                        cb={this.setRepeatingOptions('repeating')}
                                        disabled={false}
                                        errors={this.state.errors?.repeating ? true : false}
                                        helperErrors={true}
                                        label={'Select frequency of repeating'}
                                        labelColor='default'
                                        id='repeating'
                                        required={true}
                                        options={this.getRepeatsOption()}
                                        type='select'
                                        value={form.repeating}
                                    >

                                    </InputField>
                                </div>

                                {this.repeatingSection()}
                                <div className='w-full grid grid-cols-2 gap-4'>
                                    <div>
                                        <InputField
                                            borderColor='default'
                                            cb={this.inputChanged('subject')}
                                            disabled={false}
                                            errors={this.state.errors?.subject ? true : false}
                                            helperErrors={true}
                                            label={'Subject'}
                                            labelColor='default'
                                            id='subject'
                                            required={true}
                                            options={this.getSubjectOption()}
                                            type='select'
                                            value={form.subject}
                                            placeHolder='Select A Subject'
                                        >

                                        </InputField>
                                    </div>
                                    <div>
                                        <InputField
                                            borderColor='default'
                                            cb={this.inputChanged('course')}
                                            disabled={false}
                                            errors={this.state.errors?.course ? true : false}
                                            helperErrors={true}
                                            label={'Course'}
                                            labelColor='default'
                                            id='subject'
                                            required={true}
                                            options={this.getCourseOption()}
                                            type='select'
                                            value={form.course}
                                            placeHolder='Select A Course'
                                        >

                                        </InputField>
                                    </div>
                                </div>
                                <div className='w-full my-2 flex flex-row'>
                                    <InputField
                                        borderColor='default'
                                        cb={this.inputChanged('location')}
                                        disabled={false}
                                        errors={this.state.errors?.location ? true : false}
                                        helperErrors={true}
                                        label={'Location'}
                                        labelColor='default'
                                        id='location'
                                        required={false}
                                        type='text'
                                        value={form.location}
                                        placeHolder='Location of Event'
                                    >

                                    </InputField>
                                </div>
                                <div className='w-full my-2 flex flex-row'>
                                    <InputField
                                        borderColor='default'
                                        cb={this.inputChanged('provider')}
                                        disabled={false}
                                        errors={this.state.errors?.provider ? true : false}
                                        helperErrors={true}
                                        label={'Provider'}
                                        labelColor='default'
                                        id='provider'
                                        required={false}
                                        type='text'
                                        value={form.provider}
                                        placeHolder='Provider of Event'
                                    >
                                    </InputField>
                                </div>
                                <div className='w-full my-2 flex flex-row'>
                                    <InputField
                                        borderColor='default'
                                        cb={this.inputChanged('description')}
                                        disabled={false}
                                        errors={this.state.errors?.description ? true : false}
                                        helperErrors={true}
                                        label={'Event Description'}
                                        labelColor='default'
                                        id='description'
                                        type='textarea'
                                        required={false}
                                        value={form.description}
                                        numRows={2}
                                    >

                                    </InputField>
                                </div>
                            </div>
                        }
                        <div className='w-full flex flex-row items-center'>
                            <div className='w-auto grow text-right pr-4'>

                            </div>
                            <div className='w-auto flex-none justify-items-right'>
                                <button
                                    disabled={this.state.submitted}
                                    onClick={() => this.editEvent()}
                                    type="button"
                                    className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Edit Event
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

}

export default EditScheduleForm